import * as React from 'react';
export const IcCherry = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.73 11a4.39 4.39 0 00-1.27.21L12.38 5h1.9a1 1 0 100-2h-7a1 1 0 000 2H9.4L7 12.5a4.25 4.25 0 102 .35l2-6.19 2.76 5.58a4.26 4.26 0 103-1.23l-.03-.01z'
      fill='currentColor'
    />
  </svg>
);
